import 'icheck';
import Litepicker from 'litepicker';
import 'litepicker/dist/plugins/keyboardnav';

(function ($) {
    "use strict";

    $('.contact-form input[type="checkbox"], #booking-request input[type="checkbox"], #newsletter-cb').iCheck({
        checkboxClass: 'icheckbox_square-aero',
        radioClass: 'iradio_square-aero',
    });

    if ($('#date').length) {
        let picker = new Litepicker({
            element: document.getElementById('date'),
            lang: $('html').prop('lang'),
            minDate: new Date(),
            format: 'D MMM, YYYY'
        });
    }

    if ($('#dates').length) {
        let $dates = $('#dates');
        if ($dates.data('bookings')) {
            $.getJSON($('#dates').data('bookings'), function (data) {
                let bookings = data.days;
                $dates.prop('disabled', '');
                $('#boxed-booking-request button[type="submit"]').prop('disabled', '');
                new Litepicker({
                    element: document.getElementById('dates'),
                    plugins: ['keyboardnav'],
                    lang: $('html').prop('lang'),
                    minDate: new Date(),
                    format: 'D MMM, YYYY',
                    numberOfMonths: 2,
                    singleMode: false,
                    numberOfColumns: 2,
                    disallowLockDaysInRange: true,
                    minDays: parseInt($dates.data('min-nights')) + 1,
                    tooltipNumber: (totalDays) => {
                        return totalDays - 1;
                    },
                    lockDaysFilter: (date1, date2, pcikedDates) => {
                        if (!date2)
                            return ($.inArray(date1.getFullYear() + '-' + (date1.getMonth() + 1) + '-' + date1.getDate(), bookings) === -1)

                        while (date1.toJSDate() < date2.toJSDate()) {
                            if ($.inArray(date1.getFullYear() + '-' + (date1.getMonth() + 1) + '-' + date1.getDate(), bookings) === -1)
                                return true;
                            date1.add(1, 'day');
                        }
                    },
                    tooltipText: {"one":$dates.data('one'), "other":$dates.data('other')},
                    setup: (picker) => {
                        picker.on('selected', (start, end) => {

                        });
                    }
                });
            });
        } else {
            new Litepicker({
                element: document.getElementById('dates'),
                plugins: ['keyboardnav'],
                lang: $('html').prop('lang'),
                minDate: new Date(),
                format: 'D MMM, YYYY',
                numberOfMonths: 2,
                singleMode: false,
                numberOfColumns: 2,
                disallowLockDaysInRange: true,
                minDays: $dates.data('min-nights'),
                tooltipNumber: (totalDays) => {
                    return totalDays - 1;
                },
                tooltipText: {"one":$dates.data('one'), "other":$dates.data('other')},
            });
        }
    }

    if ($('#collapse-map > .map[data-lat]').length) {
        let $map = $('#collapse-map > .map');

        //set up markers
        let myMarkers = {
            "markers": [
                {"latitude": $map.data('lat'), "longitude": $map.data('long'), "icon": "/img/map-marker.png"}
            ]
        };

        //set up map options
        $map.mapmarker({
            zoom: 16,
            center: $map.data('name'),
            markers: myMarkers
        });
    }

    $('#activity-booking-request').submit(function (e) {
        e.preventDefault();
        let $this = $(this);
        let loading = $('#activity-booking-loading');
        $('#activity-booking-error').html($('#activity-booking-error').data('error')).hide();

        $this.find('button[type="submit"]').prop('disabled', 'disabled');
        loading.show();
        $.ajax({
            url: $this.attr('action'),
            method: $this.attr('method'),
            data: $this.serializeArray()
        }).done(function () {
            $this.hide();
            $('#activity-booking-success').show();
        }).fail(function (xhr) {
            if (xhr.responseJSON.message) {
                $('#activity-booking-error').html(xhr.responseJSON.message);
            }
            $('#activity-booking-error').show();
        }).always(function () {
            $this.find('button[type="submit"]').prop('disabled', '');
            loading.hide();
        });

        return false;
    });
})(window.$);
